module.exports = __webpack_public_path__ + "img/jjin_final_2.02e14aa4.jpg";